export default {
	'public-discover': 'discover',
	'public-discover-categories': 'discover-categories',
	'public-discover-results': 'discover-results',
	'public-discover-details': 'discover-details'
}
